import React from "react";
import Button from "./Button";
import Modal from "./Modal";

const UnsavedChangesDialog = ({ open, onStay, onLeave }) => (
  <Modal
    open={open}
    onClose={onStay}
    title="Leave without saving?"
    description="You have changes that haven't been saved. If you leave now they'll be lost."
    size="sm"
    footer={
      <>
        <Button variant="ghost" onClick={onLeave}>
          Leave without saving
        </Button>
        <Button variant="primary" onClick={onStay}>
          Keep editing
        </Button>
      </>
    }
  />
);

export default UnsavedChangesDialog;
